<nav class="navbar-container">
    <ul class="navbar-elements">
        <li class="nav-title text-truncate">
            {{title}}
        </li>
        <li class="search-container">
            <div class="search">
                <input class="search-input" type="text" placeholder="Buscar" autocomplete="off">
                <img class="search-icon" src="assets/icons/search.svg" alt="">
            </div>
        </li>
        <li class="support" *ngIf="!isMobile">
            <a [routerLink]="disabledLink" disabled>
                <img *ngIf="disabledLink" class="support-icon" src="assets/icons/question.png" alt="">
                <span style="color:#ccc;">
                    Soporte
                </span>
            </a>
        </li>
        <li class="user-profile">
            <div class="dropdown">
                <button class="user-btn" type="button" id="userDropdownbtn" data-toggle="dropdown" aria-haspopup="true"
                    data-bs-toggle="dropdown" aria-expanded="false">
                    <img class="user" src="assets/images/user.png" alt="assets/images/user.png">
                    <fa-icon class="arrow-icon" [icon]="faCaretDown"></fa-icon>
                </button>
                <div class="user-dropdown dropdown-menu" aria-labelledby="userDropdownbtn">
                    <div class="items-container">
                        <a class="dropdown-item" routerLink="/user/profile">Editar Perfil</a>
                        <a style="color:#ccc;" class="dropdown-item" [routerLink]="disabledLink">Solicitud de
                            permiso</a>
                        <a style="color:#ccc;" class="dropdown-item" [routerLink]="disabledLink">Accesos</a>
                        <a class="dropdown-item" [routerLink]="disabledLink" *ngIf="isMobile">Soporte</a>
                        <a class="dropdown-item" (click)="logout()">Cerrar sesión</a>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</nav>